// @flow
import { Grid } from '@material-ui/core';
import FsLightbox from 'fslightbox-react';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import pointer from '../../images/pointer.png';

type Props = {
  gallery: Array<any>,
  nombre: string,
};

const useStyles = makeStyles(() => ({
  imageWrapper: {
    cursor: `url(${pointer}), auto`,
  },
}));

const Gallery = ({ gallery, nombre }: Props) => {
  const [lsController, setLsController] = React.useState({
    toggler: false,
    slide: 1,
  });
  const classes = useStyles();
  const images = gallery.map((item) => `https:${item.fluid.srcWebp}`);

  return (
    <>
      <Grid container>
        {gallery.map((item, index) => (
          <Grid item xs={12} key={item.id} lg={6} md={6}>
            <button
              type="button"
              onClick={() =>
                setLsController({
                  toggler: !lsController.toggler,
                  slide: index + 1,
                })
              }
            >
              <GatsbyImage
                alt={nombre}
                className={classes.imageWrapper}
                loading="lazy"
                image={item.gatsbyImageData}
              />
            </button>
          </Grid>
        ))}
      </Grid>
      <FsLightbox
        toggler={lsController.toggler}
        slide={lsController.slide}
        initialAnimation="scale-in-long"
        sources={images}
      />
    </>
  );
};

export default Gallery;
